import {forwardRef, type FocusEvent} from "react";
import classes from "./form-elements.module.css";

/** Id of the label text for an input, for `aria-labelledby`. */
export const formLabelId = (inputId: string) => `${inputId}-label`;

interface FormLabelProps {
    value: string;
    active?: boolean;
    children?: React.ReactNode;
    className?: string;
    htmlFor?: string;
    onFocus?: (e: FocusEvent<HTMLLabelElement>) => void;
    onBlur?: (e: FocusEvent<HTMLLabelElement>) => void;
    "data-pw"?: string;
}

export const FormLabel = forwardRef<HTMLLabelElement, FormLabelProps>(
    (
        {value, active, children, className, htmlFor, onFocus, onBlur, "data-pw": dataPw},
        ref
    ) => (
        <label
            ref={ref}
            htmlFor={htmlFor}
            className={`${classes.labelContainer}${active ? ` ${classes.active}` : ""}${className ? ` ${className}` : ""}`}
            onFocus={onFocus}
            onBlur={onBlur}
            data-pw={dataPw}
        >
            <span
                id={htmlFor ? formLabelId(htmlFor) : undefined}
                className={`${classes.labelText}${active ? ` ${classes.active}` : ""}`}
            >
                {value}
            </span>
            {children}
        </label>
    )
);

FormLabel.displayName = "FormLabel";
